(ns common.db.sentry
  (:require [re-frame.core :as rf]))

(rf/reg-event-fx :sentry/tag-page-id
  (fn [_ [_ page-id]]
    {:fx [[:sentry/tag ["page-id" (str page-id)]]]}))

(rf/reg-event-fx :sentry/capture
  (fn [_ [_ arg]]
    {:fx [[:sentry/capture arg]]}))
